import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconPlayRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      d="M6 18.277a1 1 0 0 0 1.496.868l10.985-6.277a1 1 0 0 0 0-1.736L7.496 4.855A1 1 0 0 0 6 5.723v12.554Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconPlayRoundFill);
export default Memo;
